module.exports = __webpack_public_path__ + "img/已完成.a6838f82.svg";